export const APPLY_REQUEST = 'ApplyReducer/APPLY_REQUEST';
export const APPLY_SUCCESS = 'ApplyReducer/APPLY_SUCCESS';
export const APPLY_FAILED = 'ApplyReducer/APPLY_FAILED';
export const RATING_REQUEST = 'RatingReducer/RATING_REQUEST';
export const RATING_SUCCESS = 'RatingReducer/RATING_SUCCESS';
export const RATING_FAILED = 'RAatingeducer/RATING_FAILED';